//用于切换底图以及控制3D地形加载，用于headerContainer和mainContainer进行非父子通信
import Vue from 'vue'
const imageBus = new Vue()
export default imageBus